module.exports = __webpack_public_path__ + "img/Chat.75570829.svg";